import { Box } from '@mui/material';
import { BlogPost } from '../types';
import BlogListGrid from './BlogListGrid';

const headerColumnList = [
    {
        id: 0,
        title: 'Title',
        minWidth: '250px',
    },
    {
        id: 1,
        title: 'Summary',
        minWidth: '220px',
    },
    {
        id: 2,
        title: 'Created by',
        minWidth: '79px',
    },
    {
        id: 3,
        title: 'Created at',
        minWidth: '120px',
    },
];

interface BlogTableOrganismsProps {
    viewMode: 'grid' | 'list';
    data: BlogPost[];
    onConfirm: (params: { title: string; description: string }) => void;
    loading: boolean;
    setSelectedId: (id: string) => void;
    readOnly?: boolean;
}

const BlogTableOrganisms = ({ viewMode, data, onConfirm, loading, setSelectedId, readOnly }: BlogTableOrganismsProps) => {
    return (
        <Box sx={{ overflowX: 'auto' }}>
            {viewMode === 'grid' && (
                <BlogListGrid
                    headerColumnList={headerColumnList}
                    data={data}
                    loading={loading}
                    readOnly={readOnly}
                />
            )}
        </Box>
    );
};

export default BlogTableOrganisms;
